module.exports = __webpack_public_path__ + "static/media/img_overpaper2@2x.a315c933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_overpaper2@2x.png
// module id = 960
// module chunks = 0